// extracted by mini-css-extract-plugin
export default {"white":"profile_white__EUsp6","wrapper":"profile_wrapper__M+yJD"};